import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { SignComponent } from './sign.component';
import { SharedModule } from '../shared/shared.module';

const setupRoutes: Routes = [
    {
    path: 'sign',
    component: SignComponent
    }
];

@NgModule({
  declarations: [
    SignComponent, 
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SharedModule,
    RouterModule.forChild(setupRoutes)
  ],
  bootstrap: [
    SignComponent
  ],
  exports: [
    SignComponent  
  ]
})

export class SignModule {}